import BanReaperWidget from '../../widgets/BanReaperWidget';
import { loadWidgetData, RELOAD_INTERVAL } from './common';

export default async function mountBanReaper(host) {
	const widget = new BanReaperWidget({ container: host.container, physics: host.physics });
	await widget.init(await loadWidgetData(host, []));

	host.onSettingsChange(s => widget.applySettings(s));

	host.subscribe({
		reconnect: async () => widget.applySettings(await host.loadSettings()),
		chat: msg => { if(msg.type === 'ban' || msg.type === 'timeout') widget.onBanEvent(msg); },
	});

	host.every(async () => widget.applySettings(await host.loadSettings()), RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}
